/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerplacelink2Inputs */

const en_organizerplacelink2 = /** @type {(inputs: Organizerplacelink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create a place`)
};

const de_organizerplacelink2 = /** @type {(inputs: Organizerplacelink2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ort anlegen`)
};

/**
* | output |
* | --- |
* | "Create a place" |
*
* @param {Organizerplacelink2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerplacelink2 = /** @type {((inputs?: Organizerplacelink2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerplacelink2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerplacelink2(inputs)
	return de_organizerplacelink2(inputs)
});
export { organizerplacelink2 as "organizerPlaceLink" }